import { tabType, tabTypeToPaymentMethodMap } from '../../constants';
import { PaymentMethod } from '../../../../core/reducers/financialCalculators';
import { CUSTOMER_CASH_REBATE_NAME } from '../../../../utils/constants';
import getSpecialRateBasedOnCriterion from './getSpecialRateBasedOnCriterion';
var PaymentTabLabel;
(function (PaymentTabLabel) {
    PaymentTabLabel["lease"] = "Shared.Common.leaseMethodLabel";
    PaymentTabLabel["finance"] = "Shared.Common.financeMethodLabel";
    PaymentTabLabel["rebate"] = "Shared.Common.rebateMethodLabel";
})(PaymentTabLabel || (PaymentTabLabel = {}));
function getAvailableOffers(paymentMethod, offers, hasLoyaltyOffer) {
    var _a, _b, _c;
    const sortedOffers = [];
    const incentiveOffers = (_a = offers.incentiveOffers[paymentMethod]) !== null && _a !== void 0 ? _a : [];
    const loyaltyOffers = (_b = offers.loyaltyOffers[paymentMethod]) !== null && _b !== void 0 ? _b : [];
    const bonusOffers = (_c = offers.bonusOffers[paymentMethod]) !== null && _c !== void 0 ? _c : [];
    for (const { key, name } of incentiveOffers) {
        // eslint-disable-next-line no-continue
        if (name === CUSTOMER_CASH_REBATE_NAME)
            continue;
        sortedOffers.push({ key, name: name });
    }
    if (hasLoyaltyOffer) {
        for (const { key, name } of loyaltyOffers) {
            sortedOffers.push({ key, name: name });
        }
    }
    for (const { title, description } of bonusOffers) {
        sortedOffers.push({ key: title.value, name: title.value, disclaimer: description.value });
    }
    return sortedOffers;
}
const getCustomerCashRebate = (paymentMethod, incentiveOffers) => { var _a, _b; return ((_b = (_a = incentiveOffers === null || incentiveOffers === void 0 ? void 0 : incentiveOffers[paymentMethod]) === null || _a === void 0 ? void 0 : _a.find(({ name }) => name === CUSTOMER_CASH_REBATE_NAME)) === null || _b === void 0 ? void 0 : _b.value) || 0; };
function buildPaymentTab({ type, offers, payment, financials, fallbackPaymentTerm, fallbackPaymentFrequency, specialRateCriterion, hasLoyaltyOffer, }) {
    var _a;
    const paymentMethod = tabTypeToPaymentMethodMap[type];
    const availableOffers = getAvailableOffers(paymentMethod, offers, hasLoyaltyOffer);
    const paymentAmount = (payment === null || payment === void 0 ? void 0 : payment.preferredPaymentAmount) || 0;
    let cashRebate = 0;
    if (type === tabType.rebate) {
        cashRebate = getCustomerCashRebate(PaymentMethod.cash, offers.incentiveOffers);
        // Rebate tab should only show when the cash rebate amount is valid
        if (!cashRebate)
            return null;
        return {
            type,
            key: type,
            label: PaymentTabLabel[type],
            content: {
                rebateAmount: cashRebate,
                availableOffers,
            },
        };
    }
    const { defaultFinancePaymentFrequency, defaultLeasePaymentFrequency, defaultFinancePaymentTerm, defaultLeasePaymentTerm, } = financials;
    const defaultFrequencies = {
        lease: defaultLeasePaymentFrequency,
        finance: defaultFinancePaymentFrequency,
    };
    const defaultTerms = {
        lease: defaultLeasePaymentTerm || fallbackPaymentTerm.lease,
        finance: defaultFinancePaymentTerm || fallbackPaymentTerm.finance,
    };
    const specialRates = getSpecialRateBasedOnCriterion(offers.specialRateOffers, specialRateCriterion || '');
    const specialRate = specialRates === null || specialRates === void 0 ? void 0 : specialRates[type];
    const term = specialRate ? specialRate.term : Number(defaultTerms[type]) || (payment === null || payment === void 0 ? void 0 : payment.term) || 0;
    const paymentFrequency = (defaultFrequencies[type] || fallbackPaymentFrequency);
    const apr = specialRate
        ? specialRate.apr
        : ((_a = payment === null || payment === void 0 ? void 0 : payment.terms.find(item => item.term === Number(defaultTerms[type]))) === null || _a === void 0 ? void 0 : _a.apr) || (payment === null || payment === void 0 ? void 0 : payment.apr) || 0;
    cashRebate = getCustomerCashRebate(tabTypeToPaymentMethodMap[type], offers.incentiveOffers);
    return {
        type,
        key: type,
        label: PaymentTabLabel[type],
        content: {
            apr,
            term,
            hasSpecialRate: !!specialRate,
            paymentAmount,
            paymentFrequency,
            paymentMethod,
            availableOffers,
            cashRebate: !cashRebate ? undefined : { rebateAmount: cashRebate },
        },
    };
}
export default buildPaymentTab;
